export function clearLastProduct(catalogId: string) {
	localStorage.removeItem(`plp-product-${catalogId}`)
}
